import { types } from 'mobx-state-tree'
import PersistedImage from './persistedImage'

const Attorney = types.model('Attorney', {
  objectId: types.identifier,
  name: types.maybeNull(types.string),
  companyName: types.maybeNull(types.string),
  avatar: types.maybeNull(PersistedImage),
  letterHeaderUrl: types.maybeNull(types.string),
  bannerUrl: types.maybeNull(types.string),
  summary: types.maybeNull(types.string),
  chatEnabled: types.maybeNull(types.boolean),
})
.preProcessSnapshot(snapshot => {
  if(!snapshot) return null
  // this function will run on a snapshot to format it before submitting it to the store.
  const parsedSnapshot = {}
  const keys = Object.keys(snapshot)
  keys.forEach(key => {
    const input = snapshot[key]
    switch(key) {
      case 'avatar':
        if (input && input.url && input.name) {
          parsedSnapshot[key] = {}
          parsedSnapshot[key].persistedPointer = {
            name: input.name,
            url: input.url
          }
        }
        break
      default:
        parsedSnapshot[key] = input
        break
    }
  })

  return parsedSnapshot
})

export default Attorney